import { useEffect } from 'react'

export function Favicon({ icon }: { icon: string }) {
  useEffect(() => {
    const link: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") ||
      document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = icon
    document.querySelectorAll("link[rel*='icon']").forEach((x) => x.remove())
    document.getElementsByTagName('head')[0].appendChild(link)
  }, [icon])

  return null
}
